export const anastasiaMainInteractions = [
    {
        id: 1,
        label: 'Coffee please (2$)',
        disabled: false
    },
    {
        id: 2,
        label: 'You look gorgeous in this dress',
        disabled: true
    },
    {
        id: 3,
        label: 'Date',
        disabled: true
    },
    {
        id: 4,
        label: 'Make Love',
        disabled: true
    },
    {
        id: 5,
        label: '(Interact...)',
        disabled: true
    }
]

export const anastasiaDateInteractions = [
    {
        id: 6,
        label: 'Wanna go to the beach?',
        disabled: true
    },
    {
        id: 7,
        label: 'I"d like to invite you on a date at a restaurant. (20$)',
        disabled: true
    },
]

export const anastasiaSexInteractions = [
    {
        id: 8,
        label: 'Let"s go to my place.',
        disabled: true
    },
]
